import { find } from "ramda";

import { measureOptions } from "./options";
import { MeasureKey } from "./types";

export const findGraphTitleByMeasureKey = (key: MeasureKey | null): string => {
  const option = find((v) => v.value === key, measureOptions);
  return option === undefined ? "流入数" : option.label;
};
